import { type FC } from "react";

import { cx } from "@emotion/css";
import { Colors } from "@snapchat/snap-design-system";
import { ErrorIcon } from "@snapchat/snap-design-system-icons";

import { Flexbox } from "../../shared/components";

import { ValidationMessage, validationContainer } from "./PreviewValidationMessage.styles";

interface PreviewValidationMessageProps {
    validationMessage: string | null;
    className?: string;
}

export const PreviewValidationMessage: FC<PreviewValidationMessageProps> = ({ validationMessage, className }) => {
    if (!validationMessage) {
        return null;
    }

    return (
        <Flexbox alignItems="flex-start" className={cx(validationContainer, className)}>
            <ErrorIcon fill={Colors.Red.V150} />
            <ValidationMessage>{validationMessage}</ValidationMessage>
        </Flexbox>
    );
};
